import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05aa9166"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product-data-top-section"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_seller_filter = _resolveComponent("seller-filter");
  const _component_empty_segments = _resolveComponent("empty-segments");
  const _component_segment_filter = _resolveComponent("segment-filter");
  const _component_product_filter = _resolveComponent("product-filter");
  const _component_app_dropdown = _resolveComponent("app-dropdown");
  const _component_flex_row = _resolveComponent("flex-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_flex_row, {
    gap: 16
  }, {
    default: _withCtx(() => [_createVNode(_component_seller_filter, {
      sellers: _ctx.sellers_filter,
      onlyMode: true,
      onApply: $options.applySellers,
      onCleared: $options.clearSellers
    }, null, 8, ["sellers", "onApply", "onCleared"]), _createVNode(_component_segment_filter, {
      segments: _ctx.segments_filter,
      sellers: _ctx.sellers_filter,
      onApply: $options.applySegments
    }, {
      empty: _withCtx(() => [_createVNode(_component_empty_segments)]),
      _: 1
    }, 8, ["segments", "sellers", "onApply"]), _createVNode(_component_product_filter, {
      products: _ctx.products_filter,
      sellers: _ctx.sellers_filter,
      select_key: "content_id",
      onApply: $options.applyProducts,
      onCleared: $options.handleProductsCleared,
      onSearch: $options.searchProducts
    }, null, 8, ["products", "sellers", "onApply", "onCleared", "onSearch"]), _createVNode(_component_app_dropdown, {
      modelValue: _ctx.item,
      "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => _ctx.item = $event), $options.handleScaleTypeChange],
      options: $data.options,
      icon: "unit-scale"
    }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])]),
    _: 1
  })]);
}